module.exports = __webpack_public_path__ + "static/media/Kristin Badeau Headshot 200 X 250_1582657378413.1db5ca1b.jpg";